<shared-ui-flow-icon icon="common-file-text-search.svg" size="large">
</shared-ui-flow-icon>
<h3>{{ noDataMessage | translate }}</h3>
